import { ChartBarIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Chart = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ChartBarIcon {...rest} size={Sizes[size]} color={fill} />;
};

Chart.displayName = 'Chart';
